import React, { useState, useCallback, useEffect, useRef, VFC } from 'react';
import classnames from 'classnames';
import Button from '../common/Button/Button';
import styles from './OptionsDropdown.module.scss';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import { useUserContext } from '../../contexts/UserContext';

interface OptionsDropdownProps {
  inNavbar?: boolean;
  buttonClassName: string;
  dropdownClassName: string;
}

const OptionsDropdown: VFC<OptionsDropdownProps> = ({
  inNavbar,
  buttonClassName,
  dropdownClassName,
}) => {
  const { showLpAmounts, setShowLpAmounts } = useUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  const createHandleOptionsButtonClick = (url: string) => () => {
    window.open(url, '_blank', 'noopener noreferrer');
    setIsOpen(false);
  };

  const handleShowLpAmountToggle = (isChecked: boolean) => {
    setShowLpAmounts(isChecked);
  };

  const handleClickOutsideContainer = useCallback((_target: EventTarget | null) => {
    if (
      containerRef.current &&
      // @ts-ignore
      !containerRef.current.contains(_target)
    ) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', (ev) => handleClickOutsideContainer(ev.target));

    return document.removeEventListener('mousedown', (ev) =>
      handleClickOutsideContainer(ev.target),
    );
  }, [handleClickOutsideContainer]);

  return (
    <div ref={containerRef}>
      <Button
        className={classnames(buttonClassName, styles.ellipsisButton, inNavbar && styles.inNavbar)}
        onClick={toggleIsOpen}
      >
        <img
          src="/icons/EllipsisIcon.svg"
          alt=""
          className={classnames(styles.optionsDropdownButton, isOpen && styles.active)}
        />
      </Button>
      {isOpen && (
        <div className={classnames(dropdownClassName, styles.optionsDropdown)}>
          <div className={styles.group}>
            <p className={styles.groupTitle}>ADVANCED</p>
            <div className={styles.groupRow}>
              <p className={styles.groupRowLabel}>Show LP amounts</p>
              <ToggleSwitch checked={showLpAmounts} onChange={handleShowLpAmountToggle} />
            </div>
          </div>

          <div className={classnames(styles.group, styles.buttonsGroup)}>
            <Button
              onClick={createHandleOptionsButtonClick(
                'https://adamantfinance.gitbook.io/adamant-finance/',
              )}
            >
              Documentation
            </Button>
            <Button onClick={createHandleOptionsButtonClick('https://discord.gg/69ureKKYz2')}>
              Discord
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptionsDropdown;
